/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_HInputs */

const en_funnel_ob_daily_h = /** @type {(inputs: Funnel_Ob_Daily_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much do you want to get through a day?`)
};

const es_funnel_ob_daily_h = /** @type {(inputs: Funnel_Ob_Daily_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto quieres avanzar al día?`)
};

/**
* | output |
* | --- |
* | "How much do you want to get through a day?" |
*
* @param {Funnel_Ob_Daily_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_h = /** @type {((inputs?: Funnel_Ob_Daily_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_h(inputs)
	return en_funnel_ob_daily_h(inputs)
});